fx.ns("shared.stage.base", class BaseComponent extends fx.Component{

    constructor(data, model, parent, commands, manual)
    {
        super(data);

        this._model = model;
        this._parent = parent;
        this._manual = manual;

        this._commands = commands ? commands : [];

        this._showActions = true;

        this.assets = fx.get("assets");

        this._active = false;
        this._movableWhenActive = true;
        this._movable = true;
        this._editable = true;
        this._selectable = true;
        this._hoverable = false;

        this._toAnimate = false; //(manual && (fx.browser.isMobile || fx.browser.isTablet) /*&& this.data.creation == "manual"*/); 
        
        this._warningShowDelay = fx.get("settings").warningShowDelay || 3000;

        //this._scale = 1;
        //this.effect = "fade";
    }

    get empty()
    {
        return false;
    }
    
    get preview()
	{
		return this._preview;
	}

	set preview(val)
	{
		this._preview = val;
	}

    /*get scale()
	{
		return this._scale;
	}

	set scale(val)
	{
		this._scale = val;
	}*/

    get parentScale()
    {
        let parent = this.parent;
        while(parent && !parent.attr("scale"))
            parent = parent.parent;

        let scale = parseFloat( parent ? parent.attr("scale") : this.scale );

        return !isNaN(scale) && scale ? scale : 1;
    }

    get extraScale()
    {
        return this.model && this.model.creation && this.model.creation.extraScale ? this.model.creation.extraScale : 1;
    }


     // component displayed on single page or double page
     get single()
     {
         return this._single;
     }
 
     set single(val)
     {
         this._single = val;
     }
 
     get aspectratio()
     {
         return fx.get("app") == "config" || ((this.media && this.media.aspectratio !== undefined) ? this.media.aspectratio : true);
     }

     get flippable()
     {
        return fx.get("app") == "config" || ((this.media && this.media.flippable !== undefined) ? this.media.flippable : true);
     }
 
     get removable()
     {
        return fx.get("app") == "config" || ( (this.media && this.media.removable !== undefined) ? this.media.removable : true);
     }

     get movable()
     {
        //return (fx.get("app") == "config") || this._movable; 
        return this._resizable !== undefined ? this._movable : (fx.get("app") == "config" || ((this.media && this.media.movable !== undefined) ? this.media.movable : true));
    }

    set movable(val){
        this._movable = val;
    }

    get resizable()
    {
        return this._resizable !== undefined ? this._resizable : (fx.get("app") == "config" || ((this.media && this.media.resizable !== undefined) ? this.media.resizable : true));
    }

    set resizable(val)
    {
        this._resizable = val;
    }
 
    get selectable()
    {
        return this._selectable && !this.preview;
    }

    set selectable(val)
    {
        this._selectable = val;
    }

    get hoverable()
    {
        return this._hoverable;
    }

    set hoverable(val)
    {
        this._hoverable = val;
    }

    get editable(){
        return this._editable && !this.preview;
    }

    set editable(val){
        this._editable = val;

        this.toggleClass("not-editable", !val);
    }
    
    get active()
    {
        return this._active;
    }
    
    get showActions(){
        return this._showActions;
    }

    set showActions(val){
        this._showActions = val && !this.preview;
    }

    get movableWhenActive(){
        return this._movableWhenActive && !this.preview;
    }

    set movableWhenActive(val){
        this._movableWhenActive = val;
    }

    get parent()
    {
        return this._parent;
    }

    get manual()
    {
        return this._manual;
    }

    get model()
    {
        return this._model;
    }

    set model(val)
    {
        this._model = val;
    }

  
    get component()
    {
        return this.data;
    }

    get content(){
        return this.data ? this.data.content : "";
    }

    get x(){
        return this.data ? this.data.x : 0;
    }

    get y(){
        return this.data ? this.data.y : 0;
    }

    get xInner(){
        return this.data ? this.data.x_inner : 0;
    }

    get yInner(){
        return this.data ? this.data.y_inner : 0;
    }

    get width(){
        return this.data ? this.data.width : 0;
    }

    get height(){
        return this.data ? this.data.height : 0;
    }

    get widthInner(){
        return this.data ? this.data.width_inner : 0;
    }

    get heightInner(){
        return this.data ? this.data.height_inner : 0;
    }

    get rotationInner(){
        return this.data ? this.data.rotation_inner : 0;
    }

    get rotation(){
        return this.data ? this.data.rotation : 0;
    }

    get zoom(){
        return this.data && this.data.zoom ? this.data.zoom : 1;
    }

    get effectName(){
        return this.data ? this.data.effectName : "";
    }

    get photomask(){
        return this.data ? this.data.photomask : "";
    }

    get fontFamily(){
        return this.data && this.data.font_family ? this.data.font_family : 1;
    }
   
    get fontSize(){
        return this.data && this.data.font_size ? this.data.font_size : 12;
    }
   
    get lineHeight(){
        return (this.data && this.data.line_height) ? this.data.line_height : (this.fontSize * 1.5);
    }
   
    get align(){
        return (this.data && this.data.align) ? this.data.align : "left";
    }

    get textStyle(){
        return (this.data && this.data.text_style) ? this.data.text_style : "";
    }

    get textColor(){
        return (this.data && this.data.text_color) ? this.data.text_color : "#000";
    }
   
    get backgroundColor(){
        return (this.data && this.data.bgcolor) ? this.data.bgcolor : "rgba(0,0,0,255)";
    }
    
    get level(){
        return this.data ? this.data.level : 0;
    }

    /// ------ Commands 
    
    get allcommands(){
        return this._commands;
    }


    
    get anchorsActive()
    {
        return this._anchorsActive;
    }

    set anchorsActive(val)
    {
        this._anchorsActive = val;
    }

    
    command(tag, field, value)
    {
        let command;
        for (let i = 0; i < this.allcommands.length; i ++)
        {
            if (this.allcommands[i].tag == tag)
            {
                command = this.allcommands[i];
                break;
            }
        }

        if (command)
            command[field] = value;
                
    }

    init()
	{
        super.init();

        this.on("command", this.onCommand);
        
    }

    onCommand(event)
	{
		if (event.detail.event)
			this[event.detail.event](event.detail.value);
		else
		if (event.detail.field)
			this[event.detail.field] = event.detail.value;
		
    }

    refresh()
    {

    }
    
    onReady()
    {
        super.onReady();
    }

    onDisplayUpdated()
    {
        if (this.data)
        {
            if (this._toAnimate)
            {
                this.css({  width : this.data.width + "px", 
                            height : this.data.height + "px",
                            transform : "translate(" + this.data.x + "px," + (- this.data.height) + "px) rotate(" + Number(this.data.rotation || 0) + "deg) translate3d(0,0,0)"});

                this.delay( this._addAnimation, 0);
                
            }
            else
                this._position();

            if (!this.visible)
                this.show();
        }
        
        for (let i = 0; i < this._childs.length; i++)
			this._childs[i].updateDisplay();
    }

    _addAnimation()
    {
        this.addClass("animated");

        this.delay( this._position, 250);
    }

    _position()
    {
        if(!this.data) return;

        this.css({  width : this.data.width + "px", 
        height : this.data.height + "px",
        transform : "translate(" + this.data.x + "px," + this.data.y + "px) rotate(" + Number(this.data.rotation || 0) + "deg) translate3d(0,0,0)"});
   
        if (this._toAnimate)
            this.delay( this._removeAnimation, 500);
    }

    _removeAnimation()
    {
        this.removeClass("animated");
        
        this._toAnimate = false;
    }
   
    
   
    rotate(x, y, angle, complete/*, anchor*/)
    {
        if (this.data)
            this.data.update("rotate", {x : x, y : y, rotation : angle/*, anchor : anchor*/} );
    }

    rotateEnd()
    {
        if (this.data)
            this.data.update("rotate-end", {x : this.data.x, y : this.data.y, rotation : this.data.rotation} );
    }


    moveStart()
    {

    }

    move(x, y, angle, complete/*, anchor*/)
    {
        if (this.data)
        {
            if (angle === undefined)
                angle = this.data.rotation;

            this.data.update("move", {x : x, y : y, rotation : angle, /*anchor : anchor,*/ creation : this.data.isBackground ? this.data.creation : "moved"  } );
        }
    }

    moveEnd()
    {
        if (this.data)
            this.data.update("move-end", {x : this.data.x, y : this.data.y, rotation : this.data.rotation} );
    }


    moveInner(xInner, yInner)
    {
        if (this.data)
            this.data.update("moveinner", {x_inner : xInner, y_inner : yInner} );
    }

    moveInnerEnd()
    {
        if (this.data)
            this.data.update("moveinner-end", {x_inner : this.data.x_inner, y_inner : this.data.y_inner} );
    }

    
    resize(width, height, side)
    {
        if (width == undefined) return;

        if (this.data && (this.data.width != width || this.data.height != height))
        {
            this.data.update("resize", {width : width, height : height} );
            return true;
        }
    }

    
    resizeEnd()
    {
        if (this.data)
            this.data.update("resize-end", {width : this.data.width, height : this.data.height} );
    }

    position()
    {
    }

    updateCommands()
    {
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.impacts("x", "y", "rotation", "width", "width_inner", "height", "height_inner", "x_inner", "y_inner"))
            //this.delay(this.onDisplayUpdated, 10);
            this.onDisplayUpdated();

        /*if (action.impacts("id") && this.data)
            this.attr("data-id", this.data.id);*/

    }


    onDelete() 
	{
        if (this.data && this.removable)
            this.data.delete();
    }
    
    
    onSendDown()
    {
        if (this.data)
            this.data.update("update-level-down");
        
    }

    onSendUp()
    {
        if (this.data)
            this.data.update("update-level-up");
    }

    
    activate(val)
    {
        this._active = val;

        /*if (val)
        {
            if (this._borderWarning)
            {
                this._borderWarning.hide();
                //this._borderWarningText.hide()
            }
                
        }
        else
        {
            if (this._borderWarning)
            {
                this._borderWarning.show();
                //this._borderWarningText.show()
                this._updateWarning();
            }       
        }*/
    }

    getCommand(tag)
    {
        let command;
        
        if (this.allcommands)
        {
            for (let i = 0; i < this.allcommands.length; i ++)
            {
                if (this.allcommands[i].tag == tag)
                {
                    command = this.allcommands[i];
                    break;
                }
            }
        }
        return command;
    }

    command(tag, field, value)
    {
        let command = this.getCommand(tag);
        
        if (command)
            command[field] = value;
                
    }


    updateBorder()
    {
        if (!this.data)
            return;

        if (this.data.borderid == 0)
            this.css("outline", "none");
        else
            this.css("outline", "solid " + this.data.borderid + "px " + this.data.side);
    }

    addPositionWarning(val)
    {
        // override and add behaviour in case of position warning  
    }
    
    showWarning(create, text)
    {
        if (!this.initialized) return;
        
        if (create)
        {
            if (!this._borderWarning)
            {
                this._borderWarning = new fx.components.Image(fx.get("assets").warningElement);
                if (fx.browser.isDesktop)
                {
                    this._borderWarning.css("transform", "scale(" + this.extraScale + ")");
                    this._borderWarning.css("transform-origin", "center");
                    this.addChild(this._borderWarning, {width : 12.5, height : 12.5, left : "center", top : "center"});
                }
            }     
            
            this.toolTip = text;
        }
        else
        {
            if (this._borderWarning)
            {
                this._borderWarning.destroy();
                this._borderWarning = null;
            }
         
            this.toolTip = "";
        }
        
    }

    _updateWarning()
    {
        /*if (!this._borderWarning)
            return;

        let bbox = this._borderWarningText.node.getBBox();
        
        this._borderWarningText.scale(1/this.parent.scale);
        this._borderWarningText.translate( (this.width - bbox.width/this.parent.scale) / 2 - bbox.x/this.parent.scale,  (this.height - bbox.height/this.parent.scale) / 2 - bbox.y/this.parent.scale);

        this._borderWarning.move((this.width - this._borderWarning.width()) / 2 ,  (this.height - this._borderWarning.height()) / 2 );
        */
    }

    

});